"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroup = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const Button_1 = require("../../../../atoms/Button");
const css = (0, cssComposer_1.default)(styles);
/**
 * A collection of fields to be rendered together in a group. Supports multiple
 * group instances.
 */
const FormGroup = ({ label, description, onNewInstance, newInstanceLabel = "", children }) => (React.createElement("div", { className: css("formGroup", { "-multiValue": !!onNewInstance }), "data-test": "form-group" },
    React.createElement("header", null,
        label && React.createElement("h4", { className: css("formGroup_label") }, label),
        description && (React.createElement("p", { className: css("formGroup_description") }, description))),
    React.Children.map(children, (formInput, i) => (React.createElement("div", { key: i, className: css("formGroup_instance") }, formInput))),
    onNewInstance && (React.createElement(Button_1.BlockButton, { onClick: onNewInstance }, newInstanceLabel ? newInstanceLabel : "Click to add another entry"))));
exports.FormGroup = FormGroup;
exports.default = exports.FormGroup;
//# sourceMappingURL=index.js.map